<div class="comparissionContainer">
  <p-table [columns]="headerColumns" class="tablewrapper" [value]="rowData">
    <ng-container>
      <ng-template pTemplate="header" let-columns>
        <tr *ngIf="headerColumns && headerColumns.length">
          <th scope="col" *ngFor="let col of columns">
            {{ col }}
          </th>
        </tr>
      </ng-template>
    </ng-container>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td *ngFor="let row of rowData">
          <div *ngIf="row.editable; else displayData">
            <miq-record-input
              [recordDetail]="row"
              [isNewRecord]="true"
              (rdChange)="rdChange.emit($event)"
              [isRecordDetail]="true"
            >
            </miq-record-input>
          </div>
          <ng-template #displayData>
            <span *ngIf="!!row.translateText; else formatedValue" l10nTranslate>
              {{ row.translateText }}
            </span>
            <ng-template #formatedValue> {{ row.data | dataCellFormatter: row.column }}</ng-template>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
